export const oneHourInMs = 60 * 60 * 1000;
// TODO: remove after value is configurable via CMS/Content API (PBI-138010)
export const defaultShowtimeCutoffMinutes = 20;
